export default __webpack_public_path__ + "static/media/PEC.5f5c916d.png";